/**
 * Adapted from React Bits' SpotlightCard component.
 * https://reactbits.dev/components/spotlight-card
 */
import React from 'react';
import { styled } from '@mui/material/styles';
import { tokens } from '@/theme/foundations/tokens';
import './SpotlightCard.css';

const SpotlightSurface = styled('div')(({ theme }) => {
  const t = tokens(theme.palette.mode);
  return {
    '--spotlight-surface': theme.palette.background.paper,
    '--spotlight-border': t.borders.card,
    '--spotlight-border-hover': theme.palette.primary.main,
    '--spotlight-shadow': t.shadows.card,
    '--spotlight-shadow-rest': t.shadows.cardSoft,
  };
});

interface SpotlightCardProps extends React.PropsWithChildren {
  className?: string;
  style?: React.CSSProperties;
}

const SpotlightCard: React.FC<SpotlightCardProps> = ({
  children,
  className = '',
  style,
}) => {
  return (
    <SpotlightSurface
      className={`sv-react-bits-spotlight ${className}`}
      style={style}
    >
      <div className="sv-react-bits-spotlight__content">{children}</div>
    </SpotlightSurface>
  );
};

export default SpotlightCard;
